import { render, staticRenderFns } from "./siwei.vue?vue&type=template&id=c4878bc8&scoped=true&"
import script from "./siwei.vue?vue&type=script&lang=ts&"
export * from "./siwei.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4878bc8",
  null
  
)

export default component.exports